import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs'
import { NutritionPresetsTab } from '../components/settings/NutritionPresetsTab'

export default function Settings() {
  return (
    <div className="container mx-auto px-4 py-8 max-w-4xl">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
        <p className="text-gray-600 mt-2">Manage your account preferences and nutrition presets</p>
      </div>

      <Tabs defaultValue="presets" className="space-y-6">
        <TabsList>
          <TabsTrigger value="presets">Nutrition Presets</TabsTrigger>
          <TabsTrigger value="account">Account</TabsTrigger>
        </TabsList>

        <TabsContent value="presets">
          <NutritionPresetsTab />
        </TabsContent>

        <TabsContent value="account">
          <div className="text-center py-8">
            <p className="text-gray-500">Account settings coming soon</p>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  )
}